import * as React from "react";
import Svg, { Path, Defs, ClipPath, Rect, G } from "react-native-svg";
const AcademicIcon = (props) => (
    <Svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <G clipPath="url(#clip0_7904_1222)">
            <Path d="M12.668 0.666016L9.33464 3.99935V11.3327L12.668 8.33268V0.666016ZM0.667969 3.99935V13.766C0.667969 13.9327 0.834635 14.0993 1.0013 14.0993C1.06797 14.0993 1.1013 14.066 1.16797 14.066C2.06797 13.6327 3.36797 13.3327 4.33464 13.3327C5.63464 13.3327 7.03464 13.5993 8.0013 14.3327V3.99935C7.03464 3.26602 5.63464 2.99935 4.33464 2.99935C3.03464 2.99935 1.63464 3.26602 0.667969 3.99935ZM15.3346 12.9993V3.99935C14.9346 3.69935 14.5013 3.49935 14.0013 3.33268V12.3327C13.268 12.0993 12.468 11.9993 11.668 11.9993C10.5346 11.9993 8.9013 12.4327 8.0013 12.9993V14.3327C8.9013 13.766 10.5346 13.3327 11.668 13.3327C12.768 13.3327 13.9013 13.5327 14.8346 14.0327C14.9013 14.066 14.9346 14.066 15.0013 14.066C15.168 14.066 15.3346 13.8993 15.3346 13.7327V12.9993Z" fill={props?.customColor ?? "#521FAC"}/>
        </G>
        <Defs>
            <ClipPath id="clip0_7904_1222">
                <Rect width="16" height="16" fill="white"/>
            </ClipPath>
        </Defs>
    </Svg>
);
export default AcademicIcon;
